import { useEffect, useState } from 'react';
import { ApiHelper } from '../../apiHelper/ApiHelper';
import { readJson } from '../../apiHelper/readJson';
import { useSections } from '../../sections';
import OnboardingWizard from '../../components/OnboardingWizard';
import LearningHome from './LearningHome';
import AwaitingPayment, { PendingBankTransfer } from './AwaitingPayment';

// The /kurz landing: every product gets the same dashboard. Online-lesson
// students (one-on-one Individual and lecturer-led course alike) reach their
// term-voting / schedule journey through the Online-lekce section. First-time
// users (onboarding not completed) get the intro wizard on top. A buyer whose
// bank transfer hasn't arrived yet (no course access) sees the waiting screen.
export default function KurzIndex() {
    const [needsOnboarding, setNeedsOnboarding] = useState(false);
    // undefined = not yet loaded, null = none.
    const [pending, setPending] = useState<PendingBankTransfer | null | undefined>(undefined);

    const { sections } = useSections();

    const api = new ApiHelper();

    useEffect(() => {
        (async () => {
            try {
                const obRes = await api.userApi.getOnboardingList();
                const ob = await readJson(obRes);
                setNeedsOnboarding(!ob?.completed);
            } catch { /* onboarding check is best-effort */ }
        })();

        (async () => {
            try {
                const res = await api.ordersApi.pendingBankTransferList();
                setPending((await readJson(res)) ?? null);
            } catch { setPending(null); }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // A buyer with no course access yet and a pending bank transfer waits here until an admin
    // confirms the payment. Everyone else gets the normal dashboard.
    if (pending && sections.length === 0) {
        return <AwaitingPayment data={pending} />;
    }

    return (
        <>
            <LearningHome />
            {needsOnboarding && <OnboardingWizard onClose={() => setNeedsOnboarding(false)} />}
        </>
    );
}
